var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestingRoomPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16188_35613)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4761 28.5293H35.5349C36.2994 28.5293 37.0325 28.833 37.5731 29.3735C38.1136 29.9141 38.4173 30.6472 38.4173 31.4116V37.1764C38.4173 37.5586 38.2654 37.9251 37.9952 38.1954C37.7249 38.4657 37.3583 38.6175 36.9761 38.6175H11.0349C10.6527 38.6175 10.2861 38.4657 10.0159 38.1954C9.74559 37.9251 9.59375 37.5586 9.59375 37.1764V31.4116C9.59375 30.6472 9.89743 29.9141 10.438 29.3735C10.9785 28.833 11.7117 28.5293 12.4761 28.5293Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4766 28.5294V21.3235C12.4766 20.1769 12.9321 19.0772 13.7429 18.2663C14.5537 17.4555 15.6534 17 16.8001 17H31.2119C32.3585 17 33.4582 17.4555 34.2691 18.2663C35.0799 19.0772 35.5354 20.1769 35.5354 21.3235V28.5294",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0469 22.7646H18.9586C17.7647 22.7646 16.7969 23.7325 16.7969 24.9264V26.3676C16.7969 27.5615 17.7647 28.5294 18.9586 28.5294H29.0469C30.2408 28.5294 31.2086 27.5615 31.2086 26.3676V24.9264C31.2086 23.7325 30.2408 22.7646 29.0469 22.7646Z",
    fill: "white",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9766 38.6172V41.4995",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0312 38.6172V41.4995",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1016 10.0156H39.8401L37.3484 13.0198H40.0016",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 12.959H35.7948L33.7422 15.4335H35.9271H33.7422",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 7H35.3135L32.2474 10.6958H35.4854",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16188_35613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestingRoomPoi);
export default __webpack_public_path__ + "static/media/resting-room-poi.4b0342b2c0be80c96e7a5924929e66b5.svg";
export { ForwardRef as ReactComponent };